module.exports = __webpack_public_path__ + "static/img/9areaA_09.24bcb16.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダー系/9areaA_09.png
// module id = 966
// module chunks = 1